module.exports = __webpack_public_path__ + "img/photo-team5.847dbc44.jpg";